"use strict";
var _a, _b;
var accordionHeaders = document.querySelectorAll('footer .block .accordiong-header');
accordionHeaders.forEach(function (header) {
    header.addEventListener('click', function () {
        var _a;
        var parent = header.parentElement;
        if (parent) {
            (_a = parent.querySelector("ul")) === null || _a === void 0 ? void 0 : _a.classList.toggle('d-none');
        }
    });
});
(_a = document.querySelector('#scroll-to-top')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});
showHideBackToTop();
window.addEventListener('scroll', function () {
    showHideBackToTop();
});
function showHideBackToTop() {
    var _a, _b, _c, _d;
    var top = window.scrollY;
    if (top > 2000) {
        (_a = document.querySelector('#scroll-to-top')) === null || _a === void 0 ? void 0 : _a.classList.add("d-flex");
        (_b = document.querySelector('#scroll-to-top')) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
    }
    else {
        (_c = document.querySelector('#scroll-to-top')) === null || _c === void 0 ? void 0 : _c.classList.add("d-none");
        (_d = document.querySelector('#scroll-to-top')) === null || _d === void 0 ? void 0 : _d.classList.remove("d-flex");
    }
}
(_b = document.querySelector(".delivery-terms-jumper")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", function (e) {
    e.preventDefault();
    var deliveryTermsElement = document.querySelector(".delivery-terms-section");
    if (deliveryTermsElement) {
        window.scrollTo({
            top: deliveryTermsElement.offsetTop - 200,
            behavior: "smooth"
        });
    }
});
